import { inject } from '@angular/core';
import { Router, CanActivateFn, CanActivateChildFn } from '@angular/router';
import { RoleService } from './RoleService';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from '../auth.service';

export const AdminRoleGuard: CanActivateFn | CanActivateChildFn = async (route, state) =>
{
    const router: Router = inject(Router);
    const roleService: RoleService = inject(RoleService)
    // const autoLoginGuard: AutoLoginPartialRoutesGuard = inject(AutoLoginPartialRoutesGuard)
    const oauthService: OAuthService = inject(OAuthService);
    const authService: AuthService = inject(AuthService);

    await oauthService.loadDiscoveryDocumentAndTryLogin();
    let temp = oauthService.getAccessToken();
    roleService.initData();
    if(oauthService.hasValidAccessToken() && (roleService.hasRole("admin") || roleService.hasRole("employee")))
    {
        roleService.initData();
        return true;
    }else if(oauthService.hasValidAccessToken() && !roleService.hasRole("admin"))
    {
        router.navigateByUrl('/unauthorized')
        return false;
    }
    else{
        oauthService.initCodeFlow();
        return false;
    }
}
